module.exports = {"360603100":"邓埠镇","360603101":"锦江镇","360603102":"潢溪镇","360603103":"中童镇","360603104":"马荃镇","360603105":"画桥镇","360603106":"春涛镇","360603200":"平定乡","360603202":"杨溪乡","360603203":"洪湖乡","360603204":"黄庄乡","360603205":"刘家站乡","360603408":"余江县工业园区","360603409":"鹰潭市龙岗新区","360603501":"高公寨营林场","360603503":"邓家埠水稻原种场","360603504":"余江县水产场","360603505":"塘潮源林场","360603506":"张公桥农场","360603507":"青年综合垦殖场","360603508":"大桥农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360603.json
// module id = 1282
// module chunks = 0